<template>
  <el-row>
    <el-cascader
      class="hidden-xs-only"
      size="large"
      clearable
      placeholder="Search Catalog and Recipes"
      v-loading="!catalogIsDone || !usesIsDone"
      :disabled="!catalogIsDone || !usesIsDone"
      :options="options"
      @change="handleSelect"
      filterable
      ref="cascader"
      expand-trigger="hover"
    ></el-cascader>
    <el-autocomplete
      clearable
      v-loading="!catalogIsDone || !usesIsDone"
      class="hidden-sm-and-up mobile-search-bar"
      v-model="input"
      :fetch-suggestions="querySearch"
      prefix-icon="el-icon-search"
      @select="handleAutocomplete"
      :trigger-on-focus="false"
      placeholder="Search Catalog and Recipes"
    ></el-autocomplete>
  </el-row>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      options: [],
      input: '',
      catalogIsDone: false,
      usesIsDone: false
    }
  },
  computed: {
    ...mapGetters(['uses', 'getCatelog', 'categories'])
  },
  methods: {
    querySearch(queryString, cb) {
      if (queryString === '') return this.options
      const options = this.options
      const results = options.flatMap(o => {
        // TODO will have to do antoher map and filter for use/recipes
        return o.children
          .filter(
            c => c.label.toLowerCase().indexOf(queryString.toLowerCase()) === 0
          )
          .map(c => {
            return { value: c.label, type: o.value, content: c.value }
          })
      })
      cb(results)
    },
    handleAutocomplete(selection) {
      if (selection.type === 'oils') {
        this.$router.push({ path: '/catalog/0/' + selection.content.Id })
      } else if (selection.type === 'blends') {
        this.$router.push({ path: '/catalog/1/' + selection.content.Id })
      } else if (selection.type === 'supplements') {
        this.$router.push({ path: '/catalog/2/' + selection.content.Id })
      } else if (selection.type === 'uses') {
        this.$router.push({ path: '/uses/' + selection.content.Id })
      }
    },
    handleSelect(value) {
      const optionalId = typeof value[1] !== 'undefined' ? value[1].Id : ''
      if (value[0] === 'oils')
        this.$router.push({ path: '/catalog/0/' + optionalId })
      else if (value[0] === 'blends')
        this.$router.push({ path: '/catalog/1/' + optionalId })
      else if (value[0] === 'supplements')
        this.$router.push({ path: '/catalog/2/' + optionalId })
      else if (value[0] === 'uses') {
        if (typeof value[2] !== 'undefined') {
          this.$router.push({ path: '/uses/' + value[2].Id })
        } else {
          this.$router.push({ path: '/uses/' + optionalId })
        }
      }
    },
    makeChild(use) {
      return { value: use, label: use.Name }
    },
    addUses(uses) {
      if (uses.length === 0) return
      this.options.push({
        value: 'uses',
        label: 'Uses & Recipes',
        children: uses.map(this.makeChild).map(this.getRecipeCategories)
      })
      this.usesIsDone = true
    },
    getRecipeCategories(useOption) {
      const use = useOption.value
      const recipeIds = use.SubUseIds.split(',')
      return Object.assign(
        {
          children: this.categories
            .filter(u => {
              return recipeIds.includes(u.Id)
            })
            .map(this.makeChild)
        },
        useOption
      )
    },
    addCatalog(catalog) {
      if (Object.keys(catalog).length === 0) return
      this.options.push({
        value: 'oils',
        label: 'Oils',
        children: catalog[0].map(this.makeChild)
      })
      this.options.push({
        value: 'blends',
        label: 'Blends',
        children: catalog[1].map(this.makeChild)
      })
      this.options.push({
        value: 'supplements',
        label: 'Supplements',
        children: catalog[2].map(this.makeChild)
      })
      this.catalogIsDone = true
    }
  },
  watch: {
    uses: {
      handler: 'addUses',
      immediate: true
    },
    getCatelog: {
      handler: 'addCatalog',
      immediate: true
    }
  }
}
</script>

<style>
.el-cascader {
  width: 340px;
  max-width: 100%;
}
.el-autocomplete {
  width: 25%;
  min-width: 280px;
}
.mobile-search-bar {
  width: 100%;
}
</style>
